import {
  GET_ALL_USERS,
  GET_ALL_USERS_TEST,
  GET_USER,
  GET_USERS_BY_ROLE,
  ADD_USER_BY_ROLE,
} from "../actions/action.types";
import { callSecuredApi } from "../../utils/apiRequest";

export const getAllUsers = (cb) => async (dispatch) => {
  try {
    // const res = await callSecuredApi(`/user/page=${pageNumber}&${limit}`, null, "GET");
    const res = await callSecuredApi(`/user/all-users`, null, "GET");

    const { data } = res;
    dispatch({
      type: GET_ALL_USERS,
      payload: data,
    });
    cb();
  } catch (error) {
    cb(null, error);
  }
};
export const getAllUsers_x = (cb) => async (dispatch) => {
  try {
    // const res = await callSecuredApi(`/user/page=${pageNumber}&${limit}`, null, "GET");
    const res = await callSecuredApi(`/all-users`, null, "GET");

    const { data } = res;
    dispatch({
      type: GET_ALL_USERS_TEST,
      payload: data,
    });
    cb();
  } catch (error) {
    cb(null, error);
  }
};

export const getUsersByRole = (usersRole, cb) => async (dispatch) => {
  try {
    // const res = await callSecuredApi(`/user/page=${pageNumber}&${limit}`, null, "GET");
    const res = await callSecuredApi(
      `/user/fetch-users/${usersRole}`,
      null,
      "GET"
    );

    const { data, role } = res;
    dispatch({
      type: GET_USERS_BY_ROLE,
      payload: { role, data },
    });
    cb();
  } catch (error) {
    cb(null, error);
  }
};

export const updateUserRole = (userId, values, cb) => async (dispatch) => {
  try {
    const res = await callSecuredApi(
      `/user/update/role/${userId}`,
      values,
      "POST"
    );
    if (res) {
      cb();
    }
  } catch (error) {
    cb(null, error);
  }
};

export const getUserDetails =
  (cb, history = null) =>
  async (dispatch) => {
    try {
      const res = await callSecuredApi("/user/single", null, "GET");
      if (res) {
        dispatch({
          type: GET_USER,
          payload: res.data,
        });
        cb("success");
      }
    } catch (error) {
      cb("failed");
    }
  };

export const updateUserProfile =
  (userId, values, history, cb) => async (dispatch) => {
    try {
      const res = await callSecuredApi(
        `/user/update/profile/${userId}/`,
        values,
        "PATCH"
      );
      if (res) {
        cb("profile updated", null);
      }
      history.push("user/dashboard");
      dispatch(getUserDetails);
    } catch (error) {
      cb(null, error);
    }
  };

export const changePassword = (values, history, cb) => async (dispatch) => {
  try {
    const res = await callSecuredApi(`/user/change-password`, values, "PATCH");
    if (res) {
      cb("password updated", null);
    }
    history.push("user/dashboard");
    dispatch(getUserDetails);
  } catch (error) {
    cb(null, error);
  }
};

export const addFarmer = (values, cb) => async (dispatch) => {
  try {
    const res = await callSecuredApi("/user/add-farmer", values, "POST");
    if (res) {
      cb("farmer added successfully", null);
    }
    dispatch({
      type: ADD_USER_BY_ROLE,
      payload: { data: [res.data], role: "farmer" },
    });
  } catch (error) {
    cb(null, error);
  }
};
